import { Box } from "@mantine/core"

import classes from "./SegmentedBadge.module.css"

interface SegmentedBadgeProps {
  items: React.ReactNode[]
  separator?: React.ReactNode
  className?: string
  w?: string
}

export function SegmentedBadge({
  items,
  separator = <Box className={classes.separator} />,
  className,
  w,
}: SegmentedBadgeProps) {
  return (
    <Box className={`${classes.root} ${className || ""}`} w={w}>
      {items.map((item, index) => (
        <Box key={index} className={classes.item}>
          {item}
          {index < items.length - 1 && separator}
        </Box>
      ))}
    </Box>
  )
}
